import { checkEmptyTextAndZeroWidth, elementsListToHtml, getTextComponentBackgroundSpan, getTextParagraphs } from './utils';
export const updateTextComponentBackgroundColor = (html, backgroundColor) => {
  const textParagraphs = getTextParagraphs(html);
  const updatedTextParagraphs = Array.from(textParagraphs).map(paragraph => {
    const element = paragraph;
    const text = checkEmptyTextAndZeroWidth(paragraph);
    if (!text) {
      return paragraph;
    }
    const backgroundSpan = getTextComponentBackgroundSpan(element);
    if (!backgroundSpan) {
      const newBackgroundSpan = document.createElement('span');
      const paragraphContent = element.innerHTML;
      newBackgroundSpan.style.backgroundColor = backgroundColor;
      element.innerHTML = '';
      newBackgroundSpan.innerHTML = paragraphContent;
      element.append(newBackgroundSpan);
      return paragraph;
    }
    const [backgroundSpanClass] = Array.from(backgroundSpan.classList).filter(nodeClass => nodeClass.startsWith('backcolor_'));
    backgroundSpan.classList.remove(backgroundSpanClass);
    backgroundSpan.style.backgroundColor = backgroundColor;
    return paragraph;
  });
  return elementsListToHtml(updatedTextParagraphs);
};
//# sourceMappingURL=update-text-component-background-color.js.map